import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';

const RecordNavigation = ({ ids, currentId, basePath, t }) => {
  const routerNavigate = useNavigate();
  if (!ids || ids.length === 0) return null;
  const currentIndex = ids.findIndex(id => id === currentId);
  if (currentIndex === -1) return null;

  const previousId = currentIndex > 0 ? ids[currentIndex - 1] : null;
  const nextId = currentIndex < ids.length - 1 ? ids[currentIndex + 1] : null;

  const navigate = (id) => {
    if (!id) return;
    const path = basePath.replace(/^\/#/, '');
    routerNavigate(path + id);
  };

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
      backgroundColor: 'action.hover',
      borderRadius: 2,
      px: 0.5,
      py: 0.25
    }}>
      <Tooltip title={t('back')}>
        <span>
          <IconButton
            size="small"
            disabled={!previousId}
            onClick={() => navigate(previousId)}
            sx={{
              color: previousId ? 'primary.main' : 'action.disabled',
              borderRadius: 1,
              '&:hover': { backgroundColor: 'action.selected' }
            }}
          >
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Chip
        label={`${currentIndex + 1} / ${ids.length}`}
        size="small"
        variant="outlined"
        sx={{
          minWidth: 60,
          fontWeight: 500,
          fontSize: '0.75rem',
          height: 24
        }}
      />
      <Tooltip title={t('forward')}>
        <span>
          <IconButton
            size="small"
            disabled={!nextId}
            onClick={() => navigate(nextId)}
            sx={{
              color: nextId ? 'primary.main' : 'action.disabled',
              borderRadius: 1,
              '&:hover': { backgroundColor: 'action.selected' }
            }}
          >
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default RecordNavigation;
